import React from "react"
import Text from "../../common/components/Text"
import DiagnosisAgreement from "./DiagnosisAgreement"
import Tagging from "./tagging"
import styled from "styled-components"
import { Waypoint } from "react-waypoint"
import CardContainer, { CardSection } from "../../completion/components/Card"
import { startSectionTracker, endSectionTracker } from "../../completion/actions"

const getPercievedAccuracyText = () => {
  switch (window.variant) {
    case "B":
      return "Were your results helpful?"
    case "C":
      return "Were your results useful?"
    case "D":
      return "Were your results accurate?"
    default:
      return "Were your results reasonable?"
  }
}

const Container = styled(CardContainer)`
  padding: 0 0 40px;
`

const Learning = ({ differential, setDiagnosisAgreement, isProfile, first }) => (
  <Container noShadow noBorder>
    {!window.removeThumbs_ab_test &&
      !isProfile && (
        <Waypoint 
          onEnter={startSectionTracker('agreement feedback')}
          onLeave={endSectionTracker('agreement feedback')}
        >
          <div>
            <CardSection noBorder={first}>
              <Text fontWeight="regular" block>
                {getPercievedAccuracyText()}
              </Text>
              {differential &&
                differential.map((diagnosis, index) => (
                  <DiagnosisAgreement
                    name={diagnosis.diagnosis}
                    agreement={diagnosis.agree}
                    key={diagnosis.diagnosis}
                    index={index}
                    length={differential.length}
                    onSetAgreement={value => setDiagnosisAgreement(index, value)}
                  />
                ))}
            </CardSection>
          </div>
        </Waypoint>
      )}
    <Waypoint 
      onEnter={startSectionTracker('tag feedback')}
      onLeave={endSectionTracker('tag feedback')}
    >
      <div>
        <Tagging differential={differential} />
      </div>
    </Waypoint>
  </Container>
)

export default Learning



// WEBPACK FOOTER //
// ./assets/feedback/components/Learning.js